// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnBar[data-v-365ee4c4]{position:absolute;bottom:0;left:0;width:100%;background-color:#fff;padding:14px;border-top:1px solid #dee2e6}", ""]);
// Exports
module.exports = exports;
